import type { FC } from 'react';

interface AvatarIconProps {
  img: string;
  key: number;
  isSelected: boolean;
  onClick: () => void;
}

export const AvatarIcon: FC<AvatarIconProps> = ({ img, isSelected, onClick }) => {
  return (
    <img
      src={img}
      width="72"
      height="72"
      alt="avatar"
      style={{
        borderRadius: '50%',
        margin: '8px',
        border: isSelected ? '2px solid #333333' : '2px solid transparent',
        backgroundColor: isSelected ? '#333333' : 'transparent'
      }}
      onClick={onClick}
    />
  );
};
